var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlipinhoBone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 278,
    viewBox: "0 0 301 278",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184.289 244.594C260.234 244.594 298.539 233.427 298.539 154.592C298.539 73.3642 251.988 47.4403 184.289 47.4403C116.591 47.4403 70.04 73.4971 70.04 154.592C70.04 233.427 108.345 244.594 184.289 244.594Z",
    fill: "#0096FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.04 154.592C70.04 175.73 73.3651 195.006 78.6852 212.289C86.3994 237.282 98.1036 258.021 109.808 273.974C111.005 275.702 112.867 276.5 114.729 276.5C116.591 276.5 118.453 275.569 119.783 273.841L141.462 242.6C154.497 220.93 144.788 188.492 128.827 163.499C105.818 127.605 70.04 106.866 70.04 154.592Z",
    fill: "#0096FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M298.672 154.592C298.672 175.73 295.347 195.006 290.027 212.289C282.312 237.282 270.608 258.021 258.904 273.974C257.707 275.702 255.845 276.5 253.983 276.5C252.121 276.5 250.259 275.569 248.929 273.841L227.249 242.6C214.215 220.93 223.924 188.492 239.885 163.499C262.761 127.605 298.672 106.866 298.672 154.592Z",
    fill: "#0096FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M184.289 47.3073C251.988 47.3073 298.539 73.364 298.539 154.459C298.539 206.173 278.455 246.854 258.771 273.841C256.244 277.298 251.19 277.165 248.796 273.708L227.249 242.6C198.654 245.258 170.058 245.258 141.462 242.6L119.783 273.841C117.389 277.298 112.335 277.298 109.808 273.974C90.1235 246.987 70.04 206.306 70.04 154.592C70.04 73.3641 116.591 47.3073 184.289 47.3073Z",
    fill: "#0096FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M288.298 217.474C280.185 241.536 268.347 260.946 258.904 273.841C256.377 277.298 251.323 277.165 248.929 273.708L227.25 242.6C256.909 239.941 279.254 231.433 288.298 217.474Z",
    fill: "url(#paint0_linear_1_37)",
    stroke: "url(#paint1_linear_1_37)",
    strokeWidth: 0.4117,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4141 217.474C88.5272 241.536 100.365 260.946 109.808 273.841C112.335 277.298 117.389 277.165 119.783 273.708L141.462 242.467C111.67 239.941 89.4582 231.433 80.4141 217.474Z",
    fill: "url(#paint2_linear_1_37)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.758 201.388C156.758 204.545 154.197 207.104 151.038 207.104C147.88 207.104 145.319 204.545 145.319 201.388C145.319 198.23 147.88 195.671 151.038 195.671C154.197 195.671 156.758 198.23 156.758 201.388ZM222.993 201.388C222.993 204.545 220.432 207.104 217.274 207.104C214.115 207.104 211.555 204.545 211.555 201.388C211.555 198.23 214.115 195.671 217.274 195.671C220.432 195.671 222.993 198.23 222.993 201.388Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M197.19 100.218H268.613V70.7052H197.19V100.218Z",
    fill: "url(#paint3_linear_1_37)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.739 31.3543C176.3 31.3447 170.324 25.366 170.324 17.9271C170.324 10.4824 176.309 4.5 183.757 4.5C191.205 4.5 197.191 10.4824 197.191 17.9271C197.191 25.366 191.215 31.3447 183.775 31.3543H203.176C254.249 31.3543 295.613 72.6993 295.746 123.749H190.806H3.67188V106.068H73.7239C81.9714 63.4839 119.449 31.3543 164.472 31.3543H183.739ZM229.111 74.8265H239.751C257.042 74.8265 271.007 88.7854 271.007 106.201H197.723C197.723 88.9184 211.821 74.8265 229.111 74.8265Z",
    fill: "#0035B5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_37",
    x1: 225.929,
    y1: 236.941,
    x2: 285.494,
    y2: 250.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0105566,
    stopColor: "#0035B5",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5203,
    stopColor: "#0035B5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_37",
    x1: 226.722,
    y1: 246.159,
    x2: 289.196,
    y2: 246.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0119827,
    stopColor: "#0035B5",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2284,
    stopColor: "#001D62",
    stopOpacity: 0.1149
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4279,
    stopColor: "#00081C",
    stopOpacity: 0.0363521
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5203,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_37",
    x1: 142.736,
    y1: 236.941,
    x2: 83.1717,
    y2: 250.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0105566,
    stopColor: "#0035B5",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5203,
    stopColor: "#0035B5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_37",
    x1: 232.886,
    y1: 92.4875,
    x2: 232.886,
    y2: 70.6826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0035B5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0035B5",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlipinhoBone);
export default __webpack_public_path__ + "static/media/blipinho-bone.20f9221c3c75f5d52ecf75dfc194ecbe.svg";
export { ForwardRef as ReactComponent };